export const firebaseConfig = {
  apiKey: "AIzaSyCA-vU8hK06eOY3aAD59LBghxs1C3L2AtU",
  authDomain: "visionmovie-94a95.firebaseapp.com",
  projectId: "visionmovie-94a95",
  storageBucket: "visionmovie-94a95.appspot.com",
  messagingSenderId: "592799611018",
  appId: "1:592799611018:web:33ca89834bf3b4ae175573",
  measurementId: "G-XYE4M1V5W0",
};
